// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610260155/js/" + chunkId + "." + {"44":"5d09cd83","225":"74aaafa9","481":"f9f798a6","486":"9758a7f5","770":"fc4ec166"}[chunkId] + ".0.08773760519103535.chunk.js";
};